import type { ProjectReportPeriod, ProjectReportStatus } from '@/types/project-report';

export const PROJECT_REPORT_PERIOD_LABELS: Record<ProjectReportPeriod, string> = {
  DAILY: '日报',
  WEEKLY: '周报',
  MONTHLY: '月报',
};

export const PROJECT_REPORT_PERIOD_OPTIONS = (
  Object.entries(PROJECT_REPORT_PERIOD_LABELS) as [ProjectReportPeriod, string][]
).map(([value, label]) => ({ value, label }));

export const PROJECT_REPORT_STATUS_LABELS: Record<ProjectReportStatus, string> = {
  DRAFT: '草稿',
  SUBMITTED: '已提交',
  COMMENTED: '已评论',
};

export const PROJECT_REPORT_STATUS_OPTIONS = (
  Object.entries(PROJECT_REPORT_STATUS_LABELS) as [ProjectReportStatus, string][]
).map(([value, label]) => ({ value, label }));

export function projectReportStatusTagColor(status: ProjectReportStatus): string {
  switch (status) {
    case 'DRAFT':
      return 'default';
    case 'SUBMITTED':
      return 'processing';
    case 'COMMENTED':
      return 'success';
    default:
      return 'default';
  }
}
